import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { CodeEditor } from 'axway-react-ui';

class FlowDebuggerInput extends React.Component {
	render () {
		const { header, value, onChange, type, action, secondaryAction,
			actionIcon, actionText, readOnly, valid, secondaryActionText,
			linkButton, theme } = this.props;

		return (
			<div className="flow-debugger-input">
				<div className="header">
					{header}
				</div>
				<CodeEditor
					code={value}
					mode={type}
					onChange={onChange}
					copyButton={readOnly}
					readOnly={readOnly}
					theme={theme}
					lint={!readOnly}
					lineNumbers={!readOnly}
				/>
				<div className="buttons">
					{secondaryAction && (
						<Button
							className="cancel"
							bsSize="large"
							bsStyle="link"
							onClick={secondaryAction}
						>
							{secondaryActionText}
						</Button>
					)}
					<Button
						className={linkButton ? 'cancel' : 'action'}
						bsSize="large"
						bsStyle={linkButton ? 'link' : 'primary'}
						onClick={action}
						disabled={!valid}
					>
						{
							actionIcon
							&& <span className={`gg icon-GG-${actionIcon}`} />
						}
						{actionText}
					</Button>
				</div>
			</div>
		);
	}
}

FlowDebuggerInput.defaultProps = {
	valid: true
};

FlowDebuggerInput.propTypes = {
	header: PropTypes.node,
	value: PropTypes.string,
	onChange: PropTypes.func,
	type: PropTypes.string,
	action: PropTypes.func,
	actionIcon: PropTypes.string,
	actionText: PropTypes.node,
	readOnly: PropTypes.bool,
	valid: PropTypes.bool
};

export default FlowDebuggerInput;
